export const latinToUTF8 = (latinString) => {
  try {
    if (typeof TextDecoder !== "undefined") {
      const bytes = new Uint8Array(
        [...latinString].map((c) => c.charCodeAt(0))
      );
      return new TextDecoder("utf-8").decode(bytes);
    }

    return decodeURIComponent(
      latinString
        .replace(/%/g, "%25")
        .replace(/\+/g, "%2B")
        .replace(/[^\x00-\x7F]/g, (c) => {
          return "%" + c.charCodeAt(0).toString(16);
        })
    );
  } catch (e) {
    console.error("Error decoding latinString:", e);
    return latinString;
  }
};
